var _path, _path2, _circle, _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkLockError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    viewBox: "0 0 64 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8001 30.7644V18.2026C45.8019 15.8128 45.3327 13.4461 44.4193 11.2378C43.506 9.02942 42.1665 7.02265 40.4773 5.33221C38.7881 3.64177 36.7823 2.30076 34.5746 1.38583C32.3669 0.470901 30.0006 0 27.6108 0C25.221 0 22.8547 0.470901 20.647 1.38583C18.4393 2.30076 16.4335 3.64177 14.7443 5.33221C13.055 7.02265 11.7155 9.02942 10.8022 11.2378C9.8889 13.4461 9.4197 15.8128 9.42144 18.2026V30.7644C6.99006 30.8738 4.69447 31.9165 3.0122 33.6753C1.32993 35.4342 0.39049 37.7738 0.389282 40.2077V69.8925H54.8323V40.2077C54.8311 37.7738 53.8916 35.4342 52.2094 33.6753C50.5271 31.9165 48.2315 30.8738 45.8001 30.7644ZM27.6108 6.41751C30.7352 6.42115 33.7306 7.664 35.9398 9.87337C38.149 12.0827 39.3917 15.0782 39.3951 18.2026V30.7425H15.8265V18.2026C15.8299 15.0782 17.0726 12.0827 19.2818 9.87337C21.491 7.664 24.4864 6.42115 27.6108 6.41751Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5045 45.3865C32.5048 44.5427 32.2869 43.7132 31.872 42.9785C31.4571 42.2438 30.8592 41.6288 30.1365 41.1933C29.4138 40.7578 28.5908 40.5166 27.7473 40.4931C26.9039 40.4695 26.0687 40.6644 25.3228 41.0589C24.5769 41.4534 23.9457 42.0341 23.4905 42.7445C23.0352 43.4549 22.7714 44.271 22.7246 45.1135C22.6778 45.956 22.8496 46.7962 23.2234 47.5527C23.5971 48.3092 24.1602 48.9561 24.8578 49.4308V60.0678H30.3629V49.4308C31.0228 48.9826 31.563 48.3798 31.9363 47.6748C32.3096 46.9698 32.5046 46.1842 32.5045 45.3865Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6107,
    cy: 20,
    r: 16,
    fill: "#E95832"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27294_107897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5855 15.7119C53.2809 17.801 54.916 19.4512 57.0051 20.1496C54.9305 20.8456 53.2831 22.4804 52.5852 24.5684C51.8891 22.4935 50.254 20.8459 48.1657 20.1482C50.2412 19.4492 51.8874 17.8006 52.5855 15.7119Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3906 26.017C46.9149 26.598 45.7423 27.7706 45.1613 29.2463C44.5804 27.7706 43.4078 26.598 41.932 26.017C43.4081 25.4357 44.5805 24.261 45.1613 22.7747C45.7422 24.261 46.9146 25.4357 48.3906 26.017ZM45.1613 21.5582C45.0562 21.5582 44.972 21.6213 44.951 21.7265L45.4113 21.9051C45.4042 21.8756 45.3974 21.8459 45.3908 21.8162C45.3906 21.8156 45.3905 21.815 45.3903 21.8144C45.3839 21.7852 45.3776 21.7559 45.3716 21.7265C45.3506 21.6213 45.2665 21.5582 45.1613 21.5582Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4453 20.1899C41.8643 18.6875 40.6615 17.4811 39.1695 16.9094C40.6845 16.3302 41.8685 15.1327 42.4453 13.6187C43.0137 15.1355 44.2109 16.3312 45.7262 16.9094C44.2339 17.4801 43.0179 18.6847 42.4453 20.1899Z",
    stroke: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 85.8925,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27294_107897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.0323,
    height: 21.0323,
    fill: "white",
    transform: "translate(37.6107 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicLinkLockError);
export default __webpack_public_path__ + "static/media/magic-link-lock-error.9d88b03f5eacbb66ec5f7c9e2a38849c.svg";
export { ForwardRef as ReactComponent };